export default "__VITE_ASSET__DGlBQycB__"